import React, { useState, useEffect } from 'react';
import axios from 'axios';

const STATIC_FORMULES = [
  { id: 'plat', label: 'Plat du Jour', price: 15, highlight: true,
    description: 'Notre plat du jour prepare avec des produits frais et de saison',
    included: ['Plat du jour au choix'], badge: 'Formule Decouverte' },
  { id: 'midi', label: 'Formule Midi', price: 20, highlight: false,
    description: 'Entree + Plat OU Plat + Dessert',
    included: ['Entree ou Dessert', 'Plat du jour'], badge: null },
  { id: 'complete', label: 'Formule Complete', price: 25, highlight: false,
    description: 'Entree + Plat + Dessert',
    included: ['Entree', 'Plat du jour', 'Dessert'], badge: null },
];

export default function FormulesDuJour() {
  const [platDuJour, setPlatDuJour] = useState(null);
  const [ardoiseUrl, setArdoiseUrl] = useState(null);

  useEffect(() => {
    axios.get('/api/menu/formules').then(res => {
      const formules = res.data || [];
      const f = formules.find(x => x.platDuJour || x.nom === 'Plat du Jour');
      if (f) { if (f.platDuJour) setPlatDuJour(f.platDuJour); if (f.ardoiseUrl) setArdoiseUrl(f.ardoiseUrl); }
    }).catch(() => {});
  }, []);

  return (
    <section style={{ background: 'linear-gradient(135deg,#f9f5ef 0%,#fdf8f0 100%)', padding: '56px 24px', textAlign: 'center' }}>
      <p style={{ color: '#5a7a3c', fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', fontSize: 13, marginBottom: 8 }}>NOS FORMULES</p>
      <h2 style={{ fontSize: 'clamp(1.6rem,4vw,2.2rem)', fontWeight: 800, color: '#1a2e12', marginBottom: 8 }}>Formules du Jour</h2>
      <p style={{ color: '#666', marginBottom: 40, fontSize: 15 }}>Cuisine maison, produits frais du marche</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 20, justifyContent: 'center', maxWidth: 960, margin: '0 auto' }}>
        {STATIC_FORMULES.map(f => (
          <div key={f.id} style={{
            flex: '1 1 260px', maxWidth: 300,
            background: f.highlight ? 'linear-gradient(135deg,#5a7a3c 0%,#3d5a27 100%)' : '#ffffff',
            border: f.highlight ? 'none' : '2px solid #e8e0d4',
            borderRadius: 20, padding: '32px 24px', position: 'relative',
            boxShadow: f.highlight ? '0 8px 32px rgba(90,122,60,0.35)' : '0 2px 12px rgba(0,0,0,0.07)',
            transform: f.highlight ? 'scale(1.04)' : 'scale(1)',
          }}>
            {f.badge && (
              <div style={{
                position: 'absolute', top: -12, left: '50%', transform: 'translateX(-50%)',
                background: '#f5c842', color: '#1a2e12', fontSize: 11, fontWeight: 800,
                letterSpacing: 1, padding: '4px 16px', borderRadius: 20, textTransform: 'uppercase', whiteSpace: 'nowrap',
              }}>{f.badge}</div>
            )}
            <div style={{ fontSize: 'clamp(2.2rem,6vw,2.8rem)', fontWeight: 900, color: f.highlight ? '#f5c842' : '#5a7a3c', lineHeight: 1, marginBottom: 4 }}>
              {f.price} <span style={{ fontSize: '0.45em', verticalAlign: 'middle' }}>€</span>
            </div>
            <h3 style={{ fontSize: 17, fontWeight: 700, color: f.highlight ? '#fff' : '#1a2e12', marginBottom: 8 }}>{f.label}</h3>
            <p style={{ fontSize: 13, color: f.highlight ? 'rgba(255,255,255,0.82)' : '#888', marginBottom: 16, lineHeight: 1.5 }}>
              {f.id === 'plat' && platDuJour ? platDuJour : f.description}
            </p>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {f.included.map((item, idx) => (
                <li key={idx} style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: f.highlight ? 'rgba(255,255,255,0.9)' : '#555', marginBottom: 6, justifyContent: 'center' }}>
                  <span style={{ color: f.highlight ? '#f5c842' : '#5a7a3c', fontWeight: 700 }}>✓</span>{item}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {ardoiseUrl && (
        <div style={{ marginTop: 40 }}>
          <p style={{ color: '#888', fontSize: 13, marginBottom: 12 }}>Notre ardoise du jour :</p>
          <img src={ardoiseUrl} alt="Ardoise du jour" style={{ maxWidth: '100%', width: 420, borderRadius: 20, boxShadow: '0 4px 20px rgba(0,0,0,0.15)', objectFit: 'cover' }} />
        </div>
      )}
    </section>
  );
}
